var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ag",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25ff01",
    d: "M109 47.6h464.8v464.9H109z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-120 -52.4) scale(1.1014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 47.6h693V512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 48.2h690.9v196.2H1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061ff",
    d: "M128.3 232.1h458.5v103.4H128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e20000",
    d: "M692.5 49.2v463.3H347L692.5 49.2zm-691.3 0v463.3h345.7L1.2 49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "m508.8 232.2-69.3-17.6 59-44.4-72.5 10.3 37.3-63-64.1 37.2 11.3-73.5-43.4 58-17.6-67.3-19.6 69.3-43.4-59 12.4 75.6-64.1-39.3 37.2 63-70.3-11.3 57.9 43.4-72.4 18.6h321.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/ag.b4fce458ef8bb773310af5eedd68ed5b.svg";
export { ForwardRef as ReactComponent };